export default __webpack_public_path__ + "static/media/icon-dsc.9759fe07.svg";